import { render, staticRenderFns } from "./BLContainerRFPop.vue?vue&type=template&id=e4a4c958"
import script from "./BLContainerRFPop.vue?vue&type=script&lang=js"
export * from "./BLContainerRFPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4a4c958')) {
      api.createRecord('e4a4c958', component.options)
    } else {
      api.reload('e4a4c958', component.options)
    }
    module.hot.accept("./BLContainerRFPop.vue?vue&type=template&id=e4a4c958", function () {
      api.rerender('e4a4c958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLContainerRFPop.vue"
export default component.exports